import React from 'react';
import { CircleHelp, MessagesSquare, Shuffle, Clock, Hourglass } from 'lucide-react';
import { Container, Eyebrow, H2, Reveal } from './shared';

const STATS = [
  { value: 'Ex-Wirtschaftsprüfung', label: 'Bilanzen habe ich beruflich geprüft' },
  { value: 'M.Sc.', label: 'Business Administration' },
  { value: '8 Jahre', label: 'selbst aktiv an der Börse' },
  { value: '~30.000', label: 'Follower auf Social Media' },
];

export const StatsBar = () => (
  <section className="border-y border-line bg-navy py-10 sm:py-12" data-testid="stats-section">
    <Container className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-4">
      {STATS.map((s, i) => (
        <div key={s.value} data-testid={`stat-${i}`} className="md:border-l md:border-line md:pl-6 md:first:border-l-0 md:first:pl-0">
          <p lang="de" className="gold-text font-display text-[17px] font-extrabold leading-tight [hyphens:auto] sm:text-2xl">{s.value}</p>
          <p className="mt-1.5 text-sm leading-snug text-ink">{s.label}</p>
        </div>
      ))}
    </Container>
  </section>
);

const PROBLEMS = [
  { icon: CircleHelp, title: '„Reicht mein ETF-Sparplan?"', text: 'Du sparst brav jeden Monat, weißt aber nicht, ob das alles ist oder wie du mehr daraus machst.' },
  { icon: MessagesSquare, title: 'Jeder hat einen anderen Tipp', text: 'Instagram, TikTok, Kollegen: Alle sind sich sicher. Nur du weißt nicht, wem du glauben sollst.' },
  { icon: Shuffle, title: 'Kaufen nach Gefühl', text: 'Du kaufst, weil gerade alle darüber reden, und verkaufst beim ersten Rücksetzer in Panik.' },
  { icon: Clock, title: 'Job, Familie, Alltag', text: 'Nach Feierabend willst du keine 30 Stunden YouTube schauen, sondern einen klaren Plan, der in deinen Alltag passt.' },
];

export const Problem = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="problem-section">
    <Container>
      <Reveal className="max-w-3xl">
        <Eyebrow>Kommt dir das bekannt vor?</Eyebrow>
        <H2>Du willst investieren, aber irgendwie fühlt sich alles wie Raten an.</H2>
      </Reveal>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={i * 80}>
            <article className="h-full rounded-[24px] border border-line bg-navy p-6 transition-transform duration-300 hover:-translate-y-1" data-testid={`problem-card-${i}`}>
              <p.icon size={26} strokeWidth={1.6} className="text-brand" aria-hidden="true" />
              <h3 className="mt-5 font-display text-lg font-bold text-white">{p.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink">{p.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);

export const WhyNow = () => (
  <section className="border-y border-line bg-navy py-20 sm:py-24" data-testid="whynow-section">
    <Container>
      <Reveal className="mx-auto max-w-2xl text-center">
        <Hourglass size={28} strokeWidth={1.6} className="mx-auto text-brand" aria-hidden="true" />
        <H2 className="mt-5">Je früher du es lernst, desto länger arbeitet es für dich.</H2>
        <p className="mt-6 text-base leading-relaxed text-ink sm:text-lg">
          Je früher du anfängst, desto mehr Jahre hast du, in denen dein Wissen und dein Kapital wachsen können. Wer heute lernt, Unternehmen selbst zu bewerten, trifft jede künftige Entscheidung besser, nicht nur die nächste.
        </p>
      </Reveal>
    </Container>
  </section>
);
